module.exports = __webpack_public_path__ + "img/bsAttrCard_bg.eb459161.png";